import { HomePageConstants } from '../../../_constants';

const initialState = { getOrgLoading: true, data: '', error: false };

export function getOrgReducer(state = initialState, action) {

    switch (action.type) {
        case HomePageConstants.REQUEST_GET_ORG:
            return {
                getOrgLoading: true,
                data: '',
                error: false
            };
        case HomePageConstants.RECEIVE_GET_ORG:
            return {
                getOrgLoading: false,
                data: action.getOrg,
                error: false
            };
        case HomePageConstants.GET_ORG_ERROR:
            return {
                getOrgLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/HomePage/Organisation/getOrgList.reducer.js